import { render, staticRenderFns } from "./section-viewed.vue?vue&type=template&id=f906b672&scoped=true&"
import script from "./section-viewed.vue?vue&type=script&lang=js&"
export * from "./section-viewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f906b672",
  null
  
)

export default component.exports